import { render, staticRenderFns } from "./email.vue?vue&type=template&id=a0e6a300"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0e6a300')) {
      api.createRecord('a0e6a300', component.options)
    } else {
      api.reload('a0e6a300', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=a0e6a300", function () {
      api.rerender('a0e6a300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/auth/email.vue"
export default component.exports